export default __webpack_public_path__ + "static/media/neck.b4f25314.svg";